module.exports = __webpack_public_path__ + "static/media/content-dien-tu-1.7b66c829.jpg";